import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'df-host',
  template: `
    <router-outlet></router-outlet>
  `
})
export class HostComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
